module.exports = __webpack_public_path__ + "img/info-fill-icon.40fc884.svg";